document.addEventListener("DOMContentLoaded", function () {
  var newHref = 'https://quote.restroomstallsandall.com/create-a-project';

  // document.querySelectorAll('a.button').forEach(function (a) {
  //   var href = a.getAttribute('href') || '';
  //   if (href.includes('request-a-quote')) {
  //     a.setAttribute('href', newHref);
  //   }
  // });

 

  document.querySelectorAll("a.button").forEach((a) => {
    const href = a.getAttribute("href") || "";
    const text = (a.textContent || "").trim().toLowerCase();

    if (href.includes("request-a-quote") || text.includes("get your quote")) {
      a.setAttribute("href", newHref);
    }
  });

});



document.addEventListener("DOMContentLoaded", function() {
    // STEP 1: Select the two richtext elements
    const brandNameEl = document.querySelectorAll(".product__text.inline-richtext")[0];
    const brandUrlEl  = document.querySelectorAll(".product__text.inline-richtext")[1];

    if (!brandNameEl || !brandUrlEl) return;

    const brandName = brandNameEl.innerText.trim();
    const brandUrl  = brandUrlEl.innerText.trim();

    // STEP 2: Hide the original paragraphs
    brandNameEl.style.display = "none";
    brandUrlEl.style.display = "none";

    // STEP 3: Create the hyperlink
    const link = document.createElement("a");
    link.href = brandUrl.startsWith("http") ? brandUrl : "/" + brandUrl.replace(/^\/+/, '');
    link.innerText = brandName;
    // link.style.cssText = "font-weight:bold; font-size:16px; color:#000; text-decoration:none;";
    link.classList.add("custom-link-style-brand");

    // STEP 4: Insert hyperlink after the brand name element
    brandNameEl.parentNode.insertBefore(link, brandNameEl.nextSibling);
});



const btn = document.querySelector('.product-form__submit');
if (!btn) {
 // console.log('No .product-form__submit found');
} else {

  let wasLoading = btn.classList.contains('loading');

  const observer = new MutationObserver(mutations => {
    for (const m of mutations) {
      if (m.type === 'attributes' && m.attributeName === 'class') {
        
        const isLoading = btn.classList.contains('loading');
       // console.log("class changed →", btn.className);

        // 🔥 Trigger when LOADING is removed (ATC has finished)
        if (wasLoading && !isLoading) {
          //console.log("✅ 'loading' REMOVED → Add To Cart finished → opening drawer");

          fetch('/?sections=cart-drawer,cart-icon-bubble')
            .then(r => r.json())
            .then(sections => {
              const drawer = document.querySelector('cart-drawer');
              
              drawer.renderContents({
                id: Date.now(),
                sections: {
                  "cart-drawer": sections["cart-drawer"],
                  "cart-icon-bubble": sections["cart-icon-bubble"]
                }
              });

              setTimeout(() => drawer.open(), 50);
            });
        }
        wasLoading = isLoading;
      }
    }
  });

  observer.observe(btn, {
    attributes: true,
    attributeFilter: ['class'],
  });

 // console.log('👀 Watching .product-form__submit for loading class changes…');
}


document.addEventListener("click", async function (e) {
  const btn = e.target.closest(".add-to-cart-btn");
  if (!btn) return;

  e.preventDefault();
  const variantId = btn.dataset.variantId;

  const res = await fetch('/cart/add.js', {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  });

  if (res.ok) {
    window.location.href = "/cart"; // redirect to cart
  }
});


document.addEventListener('DOMContentLoaded', function () {
  // Get the quick search form and input
  const form  = document.querySelector('#quickSearch form');
  const input = document.querySelector('#nav-quick-search');

  if (!form || !input) return;

  // Make sure the field is marked as required in HTML too
  input.setAttribute('required', 'required');

  // Extra protection on submit
  form.addEventListener('submit', function (e) {
    const value = input.value.trim();

    if (!value) {
      e.preventDefault();              // stop the form from submitting
      alert('Please enter a search term.'); // or show your own message in the UI
      input.focus();
    }
  });
});


(function () {

  if (!window.location.pathname.includes('/cart')) return;

  function updateHeadingCartCount() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        document.querySelectorAll('.js-cart-count').forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = 'inline';
        });
      });
  }

  /* + / − buttons */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.quantity__button')) {
      setTimeout(updateHeadingCartCount, 1000);
    }
  });

  /* Remove item */
  document.addEventListener('click', function (e) {
    if (e.target.closest('a[href*="/cart/change"]')) {
      setTimeout(updateHeadingCartCount, 1000);
    }
  });

  /* Manual quantity typing */
  document.addEventListener('change', function (e) {
    if (e.target.matches('.quantity__input[name="updates[]"]')) {
      setTimeout(updateHeadingCartCount, 1000);
    }
  });

  /* Also catch blur (user clicks outside) */
  document.addEventListener('blur', function (e) {
    if (e.target.matches('.quantity__input[name="updates[]"]')) {
      setTimeout(updateHeadingCartCount, 1000);
    }
  }, true);

  /* Initial load */
  document.addEventListener('DOMContentLoaded', updateHeadingCartCount);

})();



let isRefreshingHeader = false;

async function fixCartBadge() {
  const cartIcon = document.querySelector('#cart-icon-bubble');
  if (!cartIcon) return;

  let bubble = cartIcon.querySelector('.cart-count-bubble');

  /* -------------------------------
     PART 1 — If bubble is missing, re-fetch header section
  --------------------------------*/
  if (!bubble && !isRefreshingHeader) {
    isRefreshingHeader = true;
    try {
      const res = await fetch('/?section_id=header');
      const html = await res.text();

      const temp = document.createElement('div');
      temp.innerHTML = html;

      const newCartIcon = temp.querySelector('#cart-icon-bubble');
      if (newCartIcon) {
        cartIcon.replaceWith(newCartIcon);
      }
    } catch (err) {
      console.warn('Cart header refresh failed', err);
    }
    isRefreshingHeader = false;
    return; // Stop here, next mutation will re-run
  }

  if (!bubble) return;

  /* -------------------------------
     PART 2 —  span-fix logic
  --------------------------------*/
  if (!bubble.querySelector('span[aria-hidden="true"]')) {
    const srText = bubble.querySelector('.visually-hidden')?.textContent || '';
    const countMatch = srText.match(/\d+/);
    const count = countMatch ? parseInt(countMatch[0]) : 0;

    const displayCount = count === 0 ? '0' : (count > 99 ? '99+' : count);

    const visibleSpan = document.createElement('span');
    visibleSpan.setAttribute('aria-hidden', 'true');
    visibleSpan.textContent = displayCount;

    bubble.prepend(visibleSpan);
  }
}

/* Run on page load */
document.addEventListener('DOMContentLoaded', fixCartBadge);

/* Run after Shopify AJAX cart updates */
document.addEventListener('ajaxComplete', fixCartBadge);
document.addEventListener('cart:updated', fixCartBadge);

/* Fallback observer (covers all dynamic DOM swaps) */
const observer = new MutationObserver(fixCartBadge);
observer.observe(document.body, { childList: true, subtree: true });

